import { render, staticRenderFns } from "./TournamentTable.vue?vue&type=template&id=a0273384&"
import script from "./TournamentTable.vue?vue&type=script&lang=js&"
export * from "./TournamentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports